import 'slick-carousel/slick/slick'

export default class ServiceSlider {

    constructor() {

        this.settings = {
            $slider : $('.js-services-slider')
        };

        this.bindUIActions();
    }

    bindUIActions() {

        if(this.settings.$slider.length) {
            this.settings.$slider.slick({
                slidesToShow: 6,
                slidesToScroll: 1,
                prevArrow: $('.js-services-previous'),
                nextArrow: $('.js-services-next'),

                responsive: [
                    {
                        breakpoint: 1280,
                        settings: {
                            slidesToShow: 5,
                        }
                    },
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 4,
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 3,
                        }
                    },
                    {
                        breakpoint: 450,
                        settings: {
                            slidesToShow: 2,
                        }
                    }
                ]
            });
        }

    }

};

new ServiceSlider();